/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import { z } from 'zod'
import { useTranslation } from 'react-i18next'
import { useMemo } from 'react'
import {isCommaSeparatedPositiveIntegerList} from 'utils/formValidation'

export const useOfferEventsSchema = () => {
    const { t } = useTranslation()

    return useMemo(() => z
        .object({
            package_item_ids: z.string().trim().refine(isCommaSeparatedPositiveIntegerList, t('Select valid package items')),
            adults: z.number().int().min(0).max(500),
            childrens: z.number().int().min(0).max(500),
        })
        .refine(
            (data) => {
                const adults = data.adults ?? 0
                const childrens = data.childrens ?? 0
                return adults + childrens > 0 && isCommaSeparatedPositiveIntegerList(data.package_item_ids)
            },
            {
                message: t('Select at least one person'),
                path: ['package_item_ids'],
            }
        ), [t])
}

export type OfferEventsInputs = z.infer<ReturnType<typeof useOfferEventsSchema>>
